import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { RegistrationConfigService } from "../registration.config";

import { IDIN_RETURN_PATH, OIDC_RETURN_PATH, OIDC_RETURN_URL_PARAMETER_NAME } from "./registration-with-idin.const";
import {
	CapturePageUrlRequest,
	GetIdinRegistrationUrlSuccessPayload,
	ValidateIbanRequest,
	ValidateIbanResponse,
} from "./registration-with-idin.model";

@Injectable({
	providedIn: "root",
})
export class RegistrationWithIdinService {
	constructor(
		private httpClient: CoreHttpClient,
		private registrationConfig: RegistrationConfigService
	) {}

	getIdinRegistrationUrl(): Observable<GetIdinRegistrationUrlSuccessPayload> {
		return this.httpClient.get<GetIdinRegistrationUrlSuccessPayload>({
			url: this.registrationConfig.getIdinRegistrationUrl(),
		});
	}

	addReturnUrlParameter(url: string, languageCode: string): string {
		const returnUrl = `${window.location.protocol}//${window.location.host}/${languageCode}/${OIDC_RETURN_PATH}`;

		return `${url}?${OIDC_RETURN_URL_PARAMETER_NAME}=${returnUrl}`;
	}

	validateIban(validateIbanRequest: ValidateIbanRequest): Observable<ValidateIbanResponse> {
		return this.httpClient.post<ValidateIbanResponse>({
			url: this.registrationConfig.getIbanVerificationUrl(),
			data: validateIbanRequest,
		});
	}

	getIdinCaptureUrl(languageCode: string): Observable<string> {
		const returnUrl = `${window.location.protocol}//${window.location.host}/${languageCode}/${IDIN_RETURN_PATH}`;

		const capturePageUrlRequest: CapturePageUrlRequest = {
			language: languageCode,
			redirectUrl: returnUrl,
		};

		return this.httpClient.post<any>({
			url: this.registrationConfig.getIdinCapturePageUrl(),
			data: capturePageUrlRequest,
		});
	}
}
